import emailjs from 'emailjs-com';
import { useForm } from "react-hook-form";

const useFormData = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
       
    };

    return { register, handleSubmit, reset, errors, onSubmit };
}

export default useFormData;